// extracted by mini-css-extract-plugin
export default {"container":"orderHistory_container__8mbHi"};